import Real_Dave from './Dave_Headshot.jpeg';
import Real_Jessica from './Jess_Headshot.jpg';
import Real_Jennifer from './Jennifer_Headshot.jpg';
import Real_Kevin from './Kevin_Headshot_Placeholder.png';
import Real_RJ from './RJ_Headshot.jpg';

export { Real_Dave, Real_Jessica, Real_Kevin, Real_Jennifer, Real_RJ };
